// Add global styles for calendar specific classes
import { createGlobalStyle } from "styled-components";

export const GlobalCalendarStyles = createGlobalStyle`
  html,
  body {
    margin: 0;
    padding: 0;
  }
  
  .pastSlot {
    opacity: 0.6;
  }

  /* Service window: time blocked for new slot creation (maintenance/service). */
  .rbc-time-slot.serviceWindowSlot {
    background-color: rgba(120, 120, 120, 0.12);
    background-image: repeating-linear-gradient(
      45deg,
      rgba(120, 120, 120, 0.18),
      rgba(120, 120, 120, 0.18) 6px,
      transparent 6px,
      transparent 12px
    );
    cursor: not-allowed;
  }
`;
